<template>
  <v-radio
    color="red"
    :value="value"
    :class="[
      selectedValue === value ? 'radio-selected' : '',
      'radio-border',
      down ? 'radio-down' : up ? 'radio-up' : '',
    ]"
  >
    <template v-slot:label>
      <div>
        <strong :class="[selectedValue === value ? 'red--text' : '']">
          {{ title }}
        </strong>
        <div>
          {{ description }}
        </div>
      </div>
    </template>
  </v-radio>
</template>

<script>
export default {
  props: {
    selectedValue: String,
    value: String,
    up: Boolean,
    down: Boolean,
    title: String,
    description: String,
  },
}
</script>

<style scoped>
.radio-border {
  border: 1px solid;
  border-color: #ccc;
  margin-bottom: 0 !important;
  padding: 1.5rem;
}
.radio-up {
  border-radius: 0.5rem 0.5rem 0px 0px;
}
.radio-down {
  border-radius: 0px 0px 0.5rem 0.5rem;
}
.radio-selected {
  background-color: #faeced;
  border-color: #f44336;
}
</style>
